import React from "react";
import {
  Select,
  MenuItem,
  Typography,
  Box,
  OutlinedInput,
} from "@mui/material";
import Button from "../../../common/Button";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const AddGroup = ({
  selectedGroup,
  handleGroupChange,
  handleNextStep,
  handleBackStep,
  onClose,
  groups = [],
}) => {
  return (
    <div style={containerStyle}>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Select existing group
      </Typography>
      <Select
        value={selectedGroup}
        onChange={handleGroupChange}
        input={<OutlinedInput />}
        displayEmpty
        fullWidth
        sx={{ mb: 2 }}
        renderValue={(selected) => {
          if (!selected) {
            return <em>Select a group</em>;
          }

          const group = groups.find((group) => group.id === selected);
          return group ? group.name : selected;
        }}
        MenuProps={MenuProps}
      >
        <MenuItem disabled value="">
          <em>Select a group</em>
        </MenuItem>
        {groups.map((group) => (
          <MenuItem key={group.id} value={group.id}>
            {group.name}
          </MenuItem>
        ))}
      </Select>
      <div style={buttonContainerStyle}>
        <Button
          onClick={handleNextStep}
          disabled={!selectedGroup}
          text="Upload to this group"
          fullWidth
        />
        <Button
          variant="outlined"
          onClick={handleBackStep}
          text="Back"
          backgroundColor="white"
          fullWidth
        />
        <Button
          variant="outlined"
          onClick={onClose}
          text="Cancel"
          backgroundColor="white"
          fullWidth
        />
      </div>
    </div>
  );
};

export default AddGroup;

const containerStyle = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
};

const buttonContainerStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  width: "100%",
};
